import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/auctions`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/auctions/${id}?include=organization,allowedLocations,managers`,
      options
    )
    .then((response) => {
      let auction = jsona.deserialize(response.data);
      delete auction.links;
      return auction;
    });
}

function add(auction) {
  const payload = jsona.serialize({
    stuff: auction,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/auctions?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function reload(auction) {
  const payload = jsona.serialize({
    stuff: auction,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/auctions/${auction.id}/reload-fees`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(auction) {
  const payload = jsona.serialize({
    stuff: auction,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/auctions/${auction.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/auctions/${id}`, options);
}
function extractAuctionDetails(data) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    responseType: "blob",
  };
  return axios.post(`${url}/auctions/extract-auction-details`,data, options);
}

export default {
  list,
  get,
  add,
  update,
  reload,
  destroy,
  extractAuctionDetails,
};
